import logo from './Images/logo.png';
import hero from './Images/hero.png';
import partner1 from './Images/partner1.png';
import partner2 from './Images/partner2.png';
import partner3 from './Images/partner3.png';
import courses from './Icons/courses.png';
import student from './Icons/student.png';
import course1 from './Images/course1.png';
import course2 from './Images/course2.png';
import course3 from './Images/course3.png';
import learn from './Images/learn.png';
import person1 from './Images/person1.png';
import person2 from './Images/person2.png';
import person3 from './Images/person3.png';
import person4 from './Images/person4.png';
import person5 from './Images/person5.png';
import person6 from './Images/person6.png';
import rectangle1 from './Images/rectangle1.png';
import rectangle2 from './Images/rectangle2.png';
import facebook from './Icons/facebook.png';
import linkedin from './Icons/linkedin.png';
import twitter from './Icons/twitter.png';
import categories1 from './Icons/categories1.png';
import categories2 from './Icons/categories2.png';
import categories3 from './Icons/categories3.png';
import categories4 from './Icons/categories4.png';
import categories5 from './Icons/categories5.png';
import categories6 from './Icons/categories6.png';
import quotes from './Images/quotes.png';
import comma from './Icons/comma.png';



export const images = {
    logo,
    hero,
    partner1,
    partner2,
    partner3,
    course1,
    course2,
    course3,
    learn,
    person1,
    person2,
    person3,
    person4,
    person5,
    person6,
    rectangle1,
    rectangle2,
    quotes
}

export const icons = {
    courses,
    student,
    facebook,
    linkedin,
    twitter,
    categories1,
    categories2,
    categories3,
    categories4,
    categories5,
    categories6,
    comma
}